import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Protocol } from "../types/protocol";

export const getProtocol: (config: {
  "app-id": string;
  "protocol-id": string;
}) => Promise<Protocol> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Proto "omega/query-omega/public/api/protocol")
        (Qo.Public.Api.Proto/get-protocol ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getAllProtocols: (config: {
  "app-id": string;
}) => Promise<Protocol[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Proto "omega/query-omega/public/api/protocol")
        (Qo.Public.Api.Proto/get-all-available-protocols ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};


export const searchProtocols: (config: {
  "app-id": string;
  search: string;
}) => Promise<Protocol[]> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Proto "omega/query-omega/public/api/protocol")
        (= Input ${ednString})
        (Qo.Public.Api.Proto/protocol-search Input Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
